import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10,1.5A1.5,1.5,0,0,0,8.5,0h-7A1.5,1.5,0,0,0,0,1.5V6A1.5,1.5,0,0,0,1.5,7.5H4a.25.25,0,0,1,.25.25v.5A.25.25,0,0,1,4,8.5H2.5a.75.75,0,0,0,0,1.5h5a.75.75,0,0,0,0-1.5H6a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,1,6,7.5H8.5A1.5,1.5,0,0,0,10,6Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }